import { CallEvent } from '../types';
import IWebPhoneService from '../IWebPhoneService';
import appManager from '@app/appManager';
import IAppLogger from '@app/lib/IAppLogger';
import { recordCallAccepted } from '../lib/callAcceptLatency';

const handleCallAnswered = (
  webPhoneService: IWebPhoneService,
  newCallEvent: CallEvent,
  logger: IAppLogger,
) => {
  logger.info(
    `Call started: ${newCallEvent.remoteIdentity}, ${newCallEvent.callId}`,
    newCallEvent,
    webPhoneService,
  );
  recordCallAccepted(newCallEvent.callId);
  appManager.events.emit<CallEvent>('phone.call.answered', newCallEvent);
};

export default handleCallAnswered;
